import { IAsset } from "../../models/Assets";
import { IAssetType } from "../../models/AssetsTypes";

// Define el tipo del estado de la aplicación
export interface AppState {
    assets: IAsset[] | null;
    assetTypes: IAssetType[] | null;
}

// Define el estado inicial de la aplicación
export const initialState: AppState = {
    assets: null,
    assetTypes: null,
};
